<ambita-landregistry-right>
  <div show="{ status == states.LOADING }" class="ambita-landregistry__loading-indicator-wrapper">
    <span class="infoland-loading-indicator"></span>
  </div>
  <div class="ambita-landregistry-right__wrapper">
    <div each="{ formattedRight in right.formatted.formattedRights }" class="ambita-landregistry-right">
      <div class="ambita-landregistry-details">
        <span class="ambita-landregistry__col-1">
          <div if="{ formattedRight.keyLines }" each="{ keyLine in formattedRight.keyLines }">
            <span each="{ item in keyLine.items }"
                  class="{ getTextItemClasses(item) } ambita-landregistry-details__col-1-line">
              { item.text }
            </span>
          </div>
        </span>

        <span class="ambita-landregistry__col-2">
          <span class="ambita-landregistry-right__details-align-left">
            { nestingSymbol(formattedRight.nestingLevel) }
          </span>
          <span each="{ item in formattedRight.headingLine.items }" class="{ getTextItemClasses(item) }">
            { item.text }
          </span>
        </span>
      </div>

      <div each="{ textLine in formattedRight.textLines }"
           class="ambita-landregistry-details ambita-landregistry__col-2">
        <span show="{ textLine.isActive == false && showHistoricLines }" class="ambita-landregistry-details__historic">
          Historisk
        </span>
        <span each="{ item in textLine.items }" class="{ getTextItemClasses(item) }">{ item.text }</span>
      </div>
      <div class="ambita-landregistry__col-3">
        <span right-key="{ right.key }"></span>
      </div>
    </div>
  </div>

  <script>
    import './order/pantebokOrder.tag';
    import { init } from './landRegistryRightController';

    init(this);
  </script>
</ambita-landregistry-right>
